import React from "react";
import styled from "styled-components";
import ContactMap from "./sections/ContactMap";
import ContactInfo from "./sections/ContactInfo";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import WhatsappBTN from "../../components/WhatsappBTN";
const ContactUI = styled.section`
  width: 100%;
  height: calc(100vh - 90px);
  background-color: var(--black);
  margin-top: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  @media (max-width: 992px) {
    height: unset;
  }
  @media screen and (max-width: 675px) {
    flex-direction: column-reverse;
  }
`;

const ContactPage = () => {
  return (
    <>
      <WhatsappBTN />
      <Header />
      <ContactUI>
        <ContactMap />
        <ContactInfo />
      </ContactUI>

      <Footer />
    </>
  );
};

export default ContactPage;
